import React, {
  useState,
  useEffect,
  forwardRef,
  useImperativeHandle,
} from "react";
import axios from "axios";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCommentDots } from '@fortawesome/free-solid-svg-icons';

interface Conversation {
  id: string;
  title: string;
  messages: any[];
}

interface HistoryProps {
  onConversationSelect: (conversation: Conversation) => void;
  onConversationRemove?: (conversationId: string) => void;
}

const API_BASE_URL =
  process.env.REACT_APP_API_URL || "http://localhost:8000";

const History = forwardRef((props: HistoryProps, ref) => {
  const [history, setHistory] = useState<Conversation[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchHistory();
  }, []);

  const fetchHistory = async () => {
    setLoading(true);

    try {
      const response = await axios.get(
        `${API_BASE_URL}/api/chat/history`
      );

      setHistory(response.data);

    } catch (err) {

      console.error(err);

    } finally {

      setLoading(false);

    }
  };

  const removeConversation = async (id: string) => {
    try {

      await axios.delete(
        `${API_BASE_URL}/api/chat/history/${encodeURIComponent(id)}`
      );

      props.onConversationRemove?.(id);

      fetchHistory();

    } catch (err) {

      console.error(err);

    }
  };

  useImperativeHandle(ref, () => ({
    fetchHistory,
  }));

  if (loading) {
    return (
      <div className="history-loading">

        Loading...

      </div>
    );
  }

  return (
    <div className="history-list">

      {history.length === 0 && (
        <div className="history-empty">
          No conversations
        </div>
      )}

      {history.map((chat) => (

        <div
          key={chat.id}
          className="history-card"
        >

          <button
            className="history-title"
            onClick={() =>
              props.onConversationSelect(chat)
            }
          >
            <FontAwesomeIcon icon={faCommentDots} /> {chat.title || "New Conversation"}
          </button>

          <button
            className="history-delete"
            onClick={() =>
              removeConversation(chat.id)
            }
          >
            ✕
          </button>

        </div>

      ))}

    </div>
  );
});

export default History;